<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Listado de préstamos</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Cuentas por cobrar</a></li>
                <li class="breadcrumb-item active">Listado de préstamos</li>
            </ol>
        </div>
        <div class="card">
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Cliente</th>
                            <th>Monto</th>
                            <th>Saldo</th>
                            <th>Estado</th>
                            <th>Límite de pago</th>
                            <th>Fecha</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="loan in loans" :key="loan.id">
                            <td>{{loan.name}}</td>
                            <td>{{loan.nameClient}}</td>
                            <td>{{mymoney(loan.amount)}}</td>
                            <td>{{mymoney(loan.balance)}}</td>
                            <td>
                                <span class="btn btn-danger btn-sm" v-if="loan.state===0">Anulado</span>
                                <span class="btn btn-warning btn-sm" v-if="loan.state===2">Pendiente</span>
                                <span class="btn btn-success btn-sm" v-if="loan.state===1">Pagado</span>
                            </td>
                            <td>{{convertDate(loan.paymentLimitDate)}}</td>
                            <td>{{convertDate(loan.sale_date)}}</td>
                            <td class="btn-group mr-2" role="group" aria-label="First group">
                                <router-link
                                    v-tooltip.top-center="'Ver pagos'"
                                    class="btn btn-success" 
                                    :to="`/admin/cuentasporcobrar/verpagos?id=${loan.id}`">
                                <i class="icon-fa icon-fa-eye"/></router-link>
                                <router-link
                                    v-show="loan.state===2"
                                    v-tooltip.top-center="'Cobrar préstamo'"
                                    class="btn btn-warning" 
                                    :to="`/admin/cuentasporcobrar/pagar?id=${loan.id}`">
                                <i class="icon-fa icon-fa-money"/></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import { xelacode } from '../../../helpers/xelacode';
    export default {
        data() {
            return {
                loans:[]
            }
        },
        methods:{
            getloans(){
                let vm=this;
                axios.get('/api/admin/incomingloan/index')
                .then((response)=>{
                    vm.loans=response.data;
                }).catch((error)=>{
                    console.log(error);
                });
            },
            convertDate(date) {
                var newDate = date.split('-');
                return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
            },
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
        },
        mounted(){
            this.getloans();
        }
        
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/incomingLoan/ListIncomingLoan.vue